<template lang="html">

  <section class="ficha -practica">

    <template v-if="!!data">
      <h2 class="ficha-title" :style="styles.colorBasic">Requisitos</h2>
      <article class="group">
          <div class="contenedor-data -full" v-if="data.requisitos.idiomas && dominios.dominios.idiomas">
            <h4 class="data-title" :style="styles.colorBasic">Idiomas</h4>
            <p v-for="idioma in data.requisitos.idiomas" class="w-100">{{dominios.dominios.idiomas[idioma.idIdioma]}} - {{dominios.dominios.nivelesIdioma[idioma.idNivel]}} - <template v-if="idioma.certificacion">Con Certificación</template>
              <template v-else>Sin Certificación</template></p>
          </div>

          <div class="contenedor-data -full" v-if="data.requisitos.programasRequeridos">
            <h4 class="data-title" :style="styles.colorBasic">Programas informáticos</h4>
            <p v-for="programa in data.requisitos.programasRequeridos"  class="w-100">{{programa}}</p>
          </div>
            
          <div class="contenedor-data -full" v-if="data.requisitos.documentosRequeridos && data.requisitos.documentosRequeridos.length > 0">
            <h4 class="data-title" :style="styles.colorBasic">Documentos requeridos</h4>
            <p v-for="documento in data.requisitos.documentosRequeridos" class="w-100">{{documento.nombre}}</p>
          </div>

          <div class="contenedor-data -full" v-if="!!data.requisitos.estudiosDirigidos">
            <h4 class="data-title" :style="styles.colorBasic">Estudios a los que se dirige</h4>
            <p v-for="estudio in data.requisitos.estudiosDirigidos"  class="w-100">{{estudio}}</p>
          </div>

      </article>
    </template>

  </section>

</template>

<script lang="js">
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  import onlyArrow from '@/components/parts/icons/only-arrow';
  import arrowlink from '@/components/parts/icons/arrow-link';

  import addDocumentacion from '@/components/parts/add-documentacion';

  export default {
    name: 'ficha-practica',
    props: ['data'],
    data() {
      return {
        showadddocumentacion: false,
        uploadtype: '',
        documentacionPendiente: []
      }
    },
    mounted() {
      
    },
    methods: {
      

    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        documentos: 'getDocumentos',
        uploaddoc: 'getCanUploadDocPracticas',
        brand: 'getBrand',
        dominios: 'getDominios'
      }),

    },
    components: {
      'only-arrow': onlyArrow,
      'arrow-link': arrowlink,
      'add-documentacion': addDocumentacion
    }

  }
</script>

<style scoped lang="scss">
  .enlace-cuestionario {
    font-size: 14px;
    text-transform: uppercase;
    margin-right: 5px;
    font-weight: 600;
    width: 100%;
    text-decoration: underline;
    cursor: pointer;

    svg {
      width: 15px;
      margin-left: 5px;
    }
  }

  .add-documentacion {
    margin-top: 10px;
  }

  @media screen and (max-width: 360px) {
    .enlace-cuestionario {
      font-size: 12px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-requisitos.vue